import { SpacingAll } from '../../themes/default/spacing/index.js';
import { SpacingTokensAll } from '../../themes/default/spacing/spacing-tokens.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var themeSpacing = function themeSpacing() {
  var spacingOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedSpacing = _objectSpread({}, SpacingAll);

  var shapeTokens = Object.keys(SpacingTokensAll);
  var keys = Object.keys(spacingOverrides);
  keys.forEach(function (spacingName) {
    if (shapeTokens.indexOf(spacingName) === -1) {
      if (typeof spacingOverrides[spacingName] === 'number') {
        themedSpacing[spacingName] = spacingOverrides[spacingName];
      } else {
        console.error("Spacing override must be a number - ignoring ".concat(spacingName, " override"));
      }
    } else {
      console.error("User may not override Spacing Tokens: ".concat(Object.keys(SpacingTokensAll), " - ignoring ").concat(spacingName, " override"));
    }
  });
  return themedSpacing;
};

export { themeSpacing };
